import { jsxs, jsx } from 'react/jsx-runtime';
import React__default from 'react';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import { ReactComponent as ForwardRef$1 } from '../../assets/icons/Minus.svg.js';
import { ReactComponent as ForwardRef } from '../../assets/icons/Plus.svg.js';
import style from './NumberInput.module.css.js';
import { NumberInput as NumberInput$1 } from '../../../node_modules/.pnpm/@mui_base@5.0.0-beta.70_@types_react@18.3.23_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@mui/base/Unstable_NumberInput/NumberInput.js';

const NumberInput = React__default.forwardRef(({ error, errorMessage, ...props }, ref) => {
    const maxCharacters = Math.max(props.max.toString().length, props.min.toString().length);
    return (jsxs("div", { className: classNames(style.wrapper, props.className, props.disabled && style.disabled), children: [jsx(NumberInput$1, { slotProps: {
                    root: { className: classNames(style.root, (errorMessage || error) && style.error) },
                    input: {
                        className: style.input,
                        maxLength: maxCharacters,
                        style: { width: maxCharacters + "ch" },
                    },
                    incrementButton: {
                        className: classNames(style.button, style.incrementButton),
                        children: jsx(ForwardRef, {}),
                        type: "button",
                    },
                    decrementButton: {
                        className: classNames(style.button),
                        children: jsx(ForwardRef$1, {}),
                        type: "button",
                    },
                }, ...props, ref: ref }), errorMessage && jsx("span", { className: style.errorMessage, children: errorMessage })] }));
});
NumberInput.displayName = "NumberInput";

export { NumberInput };
//# sourceMappingURL=NumberInput.js.map
